import React, { Component } from 'react';

const ExerciseProgressCircle = React.createClass({

    getInitialState: function() {
        return {
            detailsVisible: 'hidden',
            progressStep: '2',
            totalSteps: '10',
            progress: 0
        }
    },

    onclickHandler: function() {
        const detailsVisible = this.state.detailsVisible === 'hidden' ? 'visible' : 'hidden';

        this.setState({
            detailsVisible: detailsVisible
        });
    },

    componentWillMount: function() {
        this.setState({
            progress: 158 * (this.state.progressStep / this.state.totalSteps)
        });
    },

    render: function () {

        return (
            <div
                className="exercise-progress-circle-wrap"
            >
                <svg
                    viewBox="0 0 100 100"
                    height="100"
                    width="100"
                    className="exercise-progress-circle-wrap--svg"
                    onClick={this.onclickHandler}
                >
                    <circle
                        className="exercise-progress-circle-wrap--svg-circle"
                        r="25"
                        cx="50"
                        cy="50"
                        style={{strokeDasharray: this.state.progress + ' 158'}}
                    />
                    <circle
                        r="40"
                        cx="50"
                        cy="50"
                        fill="white"
                    />
                    <text
                        className="exercise-progress-circle-wrap--svg-info"
                        x="50"
                        y="-46"
                        dangerouslySetInnerHTML={{__html: `${this.state.progressStep}/${this.state.totalSteps}`}}
                    >
                    </text>
                </svg>
                <div className={'exercise-progress-details-wrap ' + this.state.detailsVisible}>
                    <div className="exercise-progress-details">
                        <ol className="exercise-progress-details--list">
                            <li>1</li>
                            <li>2</li>
                            <li>3</li>
                            <li>4</li>
                        </ol>
                    </div>
                </div>
            </div>
        );
    }
});

export default ExerciseProgressCircle;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseProgressCircle/ExerciseProgressCircle.js
 **/